import React, {useContext} from 'react';
import DownloadIcon from '../../../assests/img/download.svg?react';
import {exportToExcel} from 'react-json-to-excel';
import {CardContext} from '../context/cardContext';
import {formatCarrierData} from '../functions/formatData';
import {FilterContext} from '../context/filterContext';
import '../../../assests/css/download.scss';
import { toast } from 'react-toastify';

export default function Download() {

    const {data} = useContext(CardContext);
    const {filterData: {carrier, contacts, coverage, facilityType,
        submissionReq, categories,
        companyCategories}} = useContext(FilterContext);
    
    const getSubmissionReqName = (id: string) => {
        const name = submissionReq.filter((req)=> req.id.toString() === id);
        if (name.length) {
            return name[0].value;
        } else {
            return 'None';
        }
    }
    
    const prepareData = (data: any) => {
        const dataToExport = data.map((eachData: any)=> {
            return ({
                "Carrier/Wholesaler Name": eachData.carrier.value,
                "Distribution": eachData.distribution,
                "Type": eachData.type,
                "Coverage": eachData.coverage.value,
                "Facility": eachData.facilityTypes.map((facility: any)=>
                    facility.value).join(', '),
                "Underwriter": eachData.contact.name,
                "Phone": eachData.contact.phone,
                "Mobile": eachData.contact.mobile,
                "Email": eachData.contact.email,
                "Submission Email": eachData.contact.submissionEmail,
                "Min CMS": eachData.minimumCms,
                "Min TIV": eachData.MinimumTiv,
                "Submission Requirements": eachData.submissionRequirements !== null? eachData.submissionRequirements
                    .split(',').map((req: string)=>
                    getSubmissionReqName(req)).join(', '): 'None',
                "Notes": eachData.notes,
                "Unique requirements": eachData.uniqueRequirements,
            });
        })
        return dataToExport;
    }
    const handleExport = () => {
        const formattedData = formatCarrierData(data, carrier, contacts,
            facilityType, coverage, categories, companyCategories);
        const dataToExport = prepareData(formattedData);
        if (dataToExport.length) {
            exportToExcel(dataToExport, `Carriers-${new Date().toLocaleDateString()}-${new Date().toLocaleTimeString()}`);
        } else {
            toast.error("No data to export");
        }
    }

    return (
        <div className="download-container"
            onClick={handleExport}>
            <div>
                <DownloadIcon width={"18"} height={"18"}/>
            </div>
        </div>
    );

}